<template>
  <Tooltip v-if="tooltipData" :show="show" :position="position">
    <table>
      <tbody>
        <tr>
          <td>{{ $t("timeline.count") }}</td>
          <td>{{ tooltipData.count }}</td>
        </tr>
        <tr>
          <td>{{ $t("timeline.percentageYear") }}</td>
          <td>{{ formatPercentage(tooltipData.percentageYear) }}</td>
        </tr>
        <tr>
          <td>{{ $t("timeline.percentageTotal") }}</td>
          <td>{{ formatPercentage(tooltipData.percentageTotal) }}</td>
        </tr>
        <tr>
          <td>{{ $t("data.year") }}</td>
          <td>{{ tooltipData.year }}</td>
        </tr>
        <tr>
          <td>
            {{ $t("data.sentiment") }}
          </td>
          <td>
            <div class="d-flex align-center">
              <div
                class="mr-2"
                :style="
                  `width: 16px; height: 16px; background: ${tooltipData.color};`
                "
              ></div>
              <div class="text-capitalize">{{ tooltipData.sentiment }}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </Tooltip>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue";
import { format } from "d3-format";

export default {
  components: {
    Tooltip
  },
  props: {
    tooltipData: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    position: {
      type: Array,
      default: () => [9999, 9999]
    }
  },
  created() {
    this.formatPercentage = format(".2%");
  }
};
</script>

<style scoped>
.tooltip-container {
  pointer-events: none;
}

td {
  vertical-align: top;
  padding: 0 16px;
}
</style>
